import React from "react";
import TopItemsTable from "../../components/Report/TopItemsTable";

const ReportTopItemsPage: React.FC = () => <TopItemsTable />;
export default ReportTopItemsPage;
